// DA-16000: легенда слоя «Wifi точки» — выбор представления (точки / плотность покрытия),
// уровень H3 в режиме агрегата и шкалы под каждое представление.
import { t } from '@lingui/macro';
import classnames from 'classnames';
import { connect } from 'react-redux';
import React, { useState } from 'react';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Radio from '@material-ui/core/Radio';
import Icon from '@material-ui/core/Icon';
import { onChangeMapFilters } from '../../../ac/onChangeMapFilters';
import { withDisplayedLayersCheck } from '../../../HOC/withDisplayedLayersCheck';
import { WIFI_AP_LAYER_ID } from '../../../constants/layers';
import { WIFI_AP_OBS_LEGEND, WIFI_AP_H3_LEGEND } from '../../../constants/legends';
import { LegendRenderer } from '../../LegendRenderer/LegendRenderer';
import { StandardRadioGroup } from '../StandardRadioGroup';
import styles from '../FilterSidebar.module.css';

const H3_ZOOMS = [ 7, 8, 9, 10, 11, 12, 'auto' ];
const WifiApComponent = ({ mapFilters, onChangeMapFilters }) => {
    const { wifiApMode = 'h3', wifiApH3Zoom = 'auto' } = mapFilters;
    const isH3 = wifiApMode === 'h3';
    const [ isH3ZoomExpanded, setIsH3ZoomExpanded ] = useState(false);
    const handleModeChange = ({ target: { value } }) => onChangeMapFilters('wifiApMode', value);
    const handleH3ZoomChange = ({ target: { value } }) => onChangeMapFilters('wifiApH3Zoom', value);
    const modes = [
        { value: 'points', label: t`точки` },
        { value: 'h3', label: t`Плотность покрытия` },
    ];

    return (
        <div>
            <div className={styles.legHead}>{t`Wifi точки:`}</div>

            <StandardRadioGroup
                value={wifiApMode}
                onChange={handleModeChange}
            >
                {modes.map(({ value, label }) => (
                    <FormControlLabel
                        key={value}
                        className={styles.isochroneFilterLabel}
                        control={
                            <Radio
                                checked={wifiApMode === value}
                                onChange={handleModeChange}
                                value={value}
                                className={classnames(styles.isochroneFilterInput, {
                                    [styles.checkedIsochroneFilterInput]: wifiApMode === value,
                                })}
                                size="small"
                            />
                        }
                        label={label}
                    />
                ))}
            </StandardRadioGroup>

            {!isH3 && (
                <div>
                    <LegendRenderer config={WIFI_AP_OBS_LEGEND} />
                    <div style={{ padding: '4px 10px 10px', fontSize: '11px', opacity: 0.75 }}>
                        {t`Видно с 12-го зума. В базе только стабильные точки: мобильные хотспоты отсеяны.`}
                    </div>
                </div>
            )}

            {isH3 && (
                <div>
                    <div
                        className={classnames(styles.legHead, {
                            [styles.expandableLegHead]: true,
                            [styles.expandableLegHeadOpen]: isH3ZoomExpanded,
                        })}
                        onClick={() => setIsH3ZoomExpanded(!isH3ZoomExpanded)}
                        style={{
                            cursor: 'pointer',
                            userSelect: 'none',
                            display: 'inline-flex',
                            alignItems: 'center',
                        }}
                    >
                        {t`H3 Zoom`}:
                        <Icon style={{ marginLeft: 'auto', transition: 'transform 0.25s ease' }}>expand_more</Icon>
                    </div>
                    {isH3ZoomExpanded && (
                        <StandardRadioGroup
                            value={String(wifiApH3Zoom)}
                            onChange={handleH3ZoomChange}
                        >
                            {H3_ZOOMS.map(zoom => (
                                <FormControlLabel
                                    key={zoom}
                                    className={styles.isochroneFilterLabel}
                                    control={
                                        <Radio
                                            checked={String(wifiApH3Zoom) === String(zoom)}
                                            onChange={handleH3ZoomChange}
                                            value={String(zoom)}
                                            className={classnames(styles.isochroneFilterInput, {
                                                [styles.checkedIsochroneFilterInput]: String(wifiApH3Zoom) === String(zoom),
                                            })}
                                            size="small"
                                        />
                                    }
                                    label={zoom}
                                />
                            ))}
                        </StandardRadioGroup>
                    )}
                    <LegendRenderer config={WIFI_AP_H3_LEGEND} />
                </div>
            )}
        </div>
    );
};
const mapStateToProps = ({ mapFilters }) => ({ mapFilters });
const ConnectedComponent = connect(mapStateToProps, { onChangeMapFilters })(WifiApComponent);

export const WifiApLegend = withDisplayedLayersCheck(ConnectedComponent, WIFI_AP_LAYER_ID);
